import { Button, StackIcon } from 'shared/ui'
import { ControlledDialog } from 'shared/ui/Dialog'

import { ContactsForm } from './ContactsForm'
import { Executions } from './Executions'
import css from './Filters.module.css'
import { closeFilter, Mode, useMode } from './store'

export function Modal() {
	const mode = useMode()

	return (
		<ControlledDialog
			className={css.wrapper}
			onRequestClose={closeFilter}
			open={mode !== Mode.None}
			rootClassName={css.root}
		>
			<Button className={css.close} onClick={closeFilter}>
				<StackIcon icon='close' stroke='currentcolor' width={16} />
			</Button>

			{mode === Mode.Executions && <Executions />}
			{mode === Mode.Contacts && <ContactsForm />}
		</ControlledDialog>
	)
}
